import { DoBootstrap, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { UpgradeModule } from '@angular/upgrade/static';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import { commonsTranslateLoader, rootScopeProvider} from 'ib-web-commons/utils';
import { subscriptionModelsAppConstant } from '@src/ib-subscription-models-app-constants';
import { IbPaymentsAppModule } from 'ib-web-payments';
import { IbCPipeModule } from 'ib-web-commons/pipes';
import { IbCModalModule } from 'ib-web-commons/ib-modal';
import { IbCDirectivesModule } from 'ib-web-commons/directives';
import { DatalayerUtilsProvider, IbCDatalayerUtilsService } from 'ib-web-commons/ib-datalayer';
import { IbCommonGenericInterceptorProvider } from 'ib-web-commons/interceptor';
import { IbSubscriptionModelsPaymentsModule } from './app/features/components/ib-subscription-models-payments/ib-subscription-models-payments.module';
import { IbSubscriptionModelsNewConfirmationModule } from './app/features/components/ib-subscription-models-new-confirmation/ib-subscription-models-new-confirmation.module';
import { NgReactModule } from './app/react/ng-react.module';

export function createTranslateLoader (http: HttpClient) {
    return commonsTranslateLoader(http, [
        subscriptionModelsAppConstant.i18nRoute,
        subscriptionModelsAppConstant.generalI18nRoute
    ]);
}

const commonsModules = [
    IbCPipeModule,
    IbCModalModule,
    IbCDirectivesModule
];

const downgradedComponent: any[] = [];

@NgModule({
    declarations: [...downgradedComponent],
    imports: [
        BrowserModule,
        UpgradeModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'es'
        }),
        ...commonsModules,
        IbPaymentsAppModule,
        IbSubscriptionModelsPaymentsModule,
        IbSubscriptionModelsNewConfirmationModule,
        NgReactModule
    ],
    providers: [
        rootScopeProvider,
        DatalayerUtilsProvider,
        ...IbCommonGenericInterceptorProvider,
        IbCDatalayerUtilsService
    ]
})
export class IbSubscriptionModelsAppModule implements DoBootstrap {

    static downgradedComponent = [...downgradedComponent];
    constructor (private upgrade: UpgradeModule) {}

    // eslint-disable-next-line
    ngDoBootstrap () {
        this.upgrade.bootstrap( document.body, ['ib-subscription-models-app'], { strictDi: true });
    }
}
